/* NorShine – fælles produktkort: læg i kurv, sortering og Dawn opacity-fix. */
(function () {
  function fixOpacity(wrap) {
    var node = wrap;
    for (var i = 0; i < 10 && node; i++) {
      node.style.opacity = '1';
      node.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      node = node.parentElement;
    }
  }

  function initSort(wrap) {
    var grid = wrap.querySelector('[data-ns-ca-grid]');
    var sort = wrap.querySelector('[data-ns-ca-sort]');
    if (!grid || !sort) return;
    var original = Array.prototype.slice.call(grid.querySelectorAll('[data-ns-ca-item]'));
    var lang = wrap.dataset.lang || 'da';
    sort.addEventListener('change', function () {
      var mode = sort.value;
      var list = original.slice();
      var byPrice = function (a, b) {
        return parseInt(a.dataset.price || '0', 10) - parseInt(b.dataset.price || '0', 10);
      };
      if (mode === 'price-asc') list.sort(byPrice);
      else if (mode === 'price-desc') list.sort(function (a, b) { return byPrice(b, a); });
      else if (mode === 'title-asc') list.sort(function (a, b) {
        return (a.dataset.title || '').localeCompare(b.dataset.title || '', lang);
      });
      list.forEach(function (el) { grid.appendChild(el); });
    });
  }

  function addToCart(wrap, btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var html = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = wrap.dataset.adding;

    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    var cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = ['cart-icon-bubble'];
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      sections = cartUI.getSectionsToRender().map(function (s) { return s.id; });
    }
    sections = sections.slice(0, 5);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error('add failed');
        var data = r.data;
        var hasAll = !!data.sections && sections.every(function (s) { return typeof data.sections[s] === 'string'; });
        if (cartUI && typeof cartUI.renderContents === 'function' && hasAll) {
          if (typeof cartUI.setActiveElement === 'function') cartUI.setActiveElement(btn);
          cartUI.classList.remove('is-empty');
          cartUI.renderContents(data);
        } else if (data.sections && typeof data.sections['cart-icon-bubble'] === 'string') {
          var bubble = document.getElementById('cart-icon-bubble');
          var fresh = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-ca', productVariantId: id, cartData: data });
        }
        btn.textContent = wrap.dataset.added;
        btn.classList.add('is-done');
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.disabled = false;
          btn.innerHTML = html;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = wrap.dataset.error;
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = html;
        }, 1600);
      });
  }

  function init(wrap) {
    if (wrap.dataset.nsCaReady) return;
    wrap.dataset.nsCaReady = '1';
    fixOpacity(wrap);
    setTimeout(function () { fixOpacity(wrap); }, 100);
    setTimeout(function () { fixOpacity(wrap); }, 500);
    setTimeout(function () { fixOpacity(wrap); }, 1000);
    initSort(wrap);
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ns-ca__btn');
      if (!btn || btn.disabled || !wrap.contains(btn)) return;
      e.preventDefault();
      addToCart(wrap, btn);
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ns-ca]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
